import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';

import ClientTimestamp from 'app/components/common/client-timestamp';
import Icon            from 'app/components/common/icon';
import Link            from 'app/components/common/link';
import Meta            from 'app/components/common/meta';
import ScrollTable     from 'app/components/common/scroll-table';
import CadminLayout    from 'app/components/company-admin/layout/';
import PageLoading     from 'app/components/layout/page-loading';
import {
  EmployeeDonationMatchStatuses as MatchStatuses,
}                      from 'app/constants';
import format          from 'app/helpers/format';
import paths           from 'app/paths';
import CadminSlx       from 'app/selectors/company-admin/';

const keys = ['match', 'feeCoverage', 'dfd', 'payroll'];
const keyLabelMap = {
  match: 'Donation Matches',
  feeCoverage: 'Fee Coverages',
  dfd: 'Dollars for Doers',
  payroll: 'Payroll Deductions',
};

class PageCadminUpcomingCharges extends React.PureComponent {

  constructor(props) {
    super(props);
  }

  get sortedKeys() {
    const {upcomingCharges} = this.props;
    if (!upcomingCharges) return null;
    const sortedKeys = keys.filter(key => !!upcomingCharges[key]).sort((akey, bkey) => {
      const a = upcomingCharges[akey];
      const b = upcomingCharges[bkey];
      if (a.runDateStr === b.runDateStr) return 0;
      return (a.runDateStr < b.runDateStr) ? -1 : 1;
    });
    return sortedKeys;
  }

  get isEmpty() {
    return this.sortedKeys?.length === 0;
  }

  get isLoading() {
    return !this.props.upcomingCharges;
  }

  renderRows() {
    const {upcomingCharges, company} = this.props;
    if (!upcomingCharges) return null;

    return (<>
      {this.sortedKeys.map((key, i) => {
        const charge = upcomingCharges[key];
        const label = keyLabelMap[key];
        const dateFmt = company.isLaunched
          ? moment.utc(charge.runDateStr).format('MMM DD, YYYY')
          : 'TBD';
        const link = (() => {
          if (key === 'match') return <Link className="blue-pink-hover" href={paths.cadminMatches(company.slug, {matchPaymentStatus: 'upcoming', matchStatus: MatchStatuses.APPROVED})}>View Matches</Link>;
          return null;
        })();

        return (
          <tr key={key}>
            <td className="right">{dateFmt}</td>
            <td className="right">{(key === 'feeCoverage') ? '~' : ''}{format.usd(charge.amount)}</td>
            <td>{label}</td>
            <td>
              {!!charge.useBalanceFirst && 'Wallet Balance'}
              {!!(charge.useBalanceFirst && charge.pm?.accountLabel) && <br />}
              {charge.pm?.accountLabel || ''}
            </td>
            <td>
              {link}
            </td>
          </tr>
        );
      })}
    </>);
  }

  renderUpcomingCharges() {
    const {upcomingCharges} = this.props;
    const asOf = upcomingCharges
      ? <ClientTimestamp timestamp={upcomingCharges.asOfTs} format="MMMM D [at] h:mma" showTz />
      : '...';

    return (
      <div className="ca-box">
        <div className="ca-box-header">
          <h1 className="ca-box-header-title">Upcoming Charges</h1>
          <div className="ca-box-header-controls"></div>      
        </div>
        <div className="ca-box-subheader">
          <p>Based on activity as of {asOf}</p>
          <p><strong>Amounts are not yet final.</strong></p>
        </div>
        <div className="ca-box-body">
          {this.isEmpty ? (<>
            <p>No upcoming charges at this time.</p>
          </>) : (<>
            {this.isLoading ? (<>
              <p>Loading...</p>
            </>) : (<>
              <table className="ca-box-table">
                <tbody>
                  <tr>
                    <th className="right">Date</th>
                    <th className="right">Amount</th>
                    <th>Type</th>
                    <th>Payment Method</th>
                    <th></th>
                  </tr>
                  {this.renderRows()}
                </tbody>
              </table>
            </>)}
          </>)}
        </div>
      </div>      
    );
  }

  render() {
    const {company, upcomingCharges} = this.props;
    if (!company) return <PageLoading />;

    return (
      <CadminLayout company={company} activeItem="upcoming-charges">
        <Meta title="Upcoming Charges | Millie" />
        {this.renderUpcomingCharges()}
      </CadminLayout>
    );
  }

}

const stateToProps = (state) => ({
  company: CadminSlx.company(state),
  upcomingCharges: CadminSlx.upcomingCharges(state),
});

const dispatchToProps = (dispatch) => ({
});

export default connect(stateToProps, dispatchToProps)(PageCadminUpcomingCharges);
